// handy functions for date objects
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat
// get date range between two dates for dropdowns etc

export const formatDate = (
  date: Date,
  locale?: string,
  options?: object,
): string => {
  return new Intl.DateTimeFormat(locale, options).format(date);
};
export const getDateRangeArray = function (startDate: Date, endDate: Date) {
  const dateList = [];
  const startDateObj = new Date(startDate);
  for (
    ;
    startDateObj <= new Date(endDate);
    startDateObj.setDate(startDateObj.getDate() + 1)
  ) {
    dateList.push(new Date(startDateObj));
  }
  return dateList;
};
// type for bump scheduler date format: Monday, 23 Oct
export const weekdayDateMonth: Intl.DateTimeFormatOptions = {
  weekday: 'long',
  day: 'numeric',
  month: 'short',
};
export const formatted24HoursArray = function (isCurrentDaySelected: boolean) {
  const times = [];
  let formattedHours;
  for (let i = 0; i < 24; i++) {
    if (i < 10) {
      formattedHours = '0' + i;
    } else formattedHours = i;
    times.push(formattedHours);
  }
  // only give remaining hours for today's date
  if (isCurrentDaySelected) {
    const currentHour = new Date().getHours();
    return times.slice(currentHour);
  } else {
    return times;
  }
};

// a function that checks whether the selected value is today  - this will determine whether the hours list will display the full 24 hour or just the remainder of the day
export const isCurrentDaySelected = function (
  selectedDate?: string,
  weekdayDateMonth?: Intl.DateTimeFormatOptions,
) {
  const todaysDate = formatDate(new Date(), 'en-gb', weekdayDateMonth);
  return selectedDate === todaysDate;
};

export const isCurrentTimeSelected = function (selectedDateTime: Date) {
  const todaysDate = new Date().getTime();
  const formattedSelected = selectedDateTime.getTime();

  return formattedSelected <= todaysDate;
};

// get the selected hour and determine the minute intervals based on that
export const getFiveMinuteIntervalsInAnHour = function () {
  const timeInterval = [
    '00',
    '05',
    '10',
    '15',
    '20',
    '25',
    '30',
    '35',
    '40',
    '45',
    '50',
    '55',
  ];

  return timeInterval.map((minutes) => minutes);
};
